import React from "react";
import { createRoot } from "react-dom/client";
import Summary from "../jsx/summary";
import Bulletins from "../jsx/bulletins";
import "../css/bulletin.css";
import "../css/summary.css";

document.addEventListener("DOMContentLoaded", () => {
    const bulletins = document.getElementById('bulletins');
    const bulletinsRoot = createRoot(bulletins);
    bulletinsRoot.render(<Bulletins />);

    const summary = document.getElementById('summary');
    const summaryRoot = createRoot(summary);
    summaryRoot.render(<Summary />)
});